import utils from '@/mixins/utils.js'

// Função para verificar pendências baseada nos alertas da TabelaCadastros.vue
function verificarPendencias(item) {
  // Se não tem primeira consulta odontológica, mostra pendência
  if (item.num_prim_cons_odonto == null || item.num_prim_cons_odonto == 0) {
    return 'Sem 1ª consulta'
  }

  return ''
}

export const dataFields = {
  Nome: 'no_cidadao',
  'Data de nascimento': {
    callback: (item) => {
      let idade = `${utils.methods.formatDate(item.dt_nascimento)} (${
        item.idade
      } ${item.idade > 1 ? 'anos' : 'ano'})`
      return idade
    },
  },
  Mãe: 'no_mae',
  Atual: {
    callback: (item) => {
      return item.pcp_atual != null
        ? utils.methods.formatDate(item.pcp_atual)
        : ''
    },
  },
  Microárea: 'micro_area',
  CPF: {
    field: 'nu_cpf',
    callback: (value) => {
      return value !== '' ? `​  ​​${value.toString()}` : ''
    },
  },
  CNS: {
    field: 'nu_cns',
    callback: (value) => {
      return value !== '' ? `​  ​​${value.toString()}` : ''
    },
  },
  'Cadastrado por': 'no_profissional',
  Atendimento: {
    callback: (item) => {
      return item.dados
    },
  },
}

export const infoHtml = ``
